module.exports = __webpack_public_path__ + "img/wz.99a96514.png";